import { render, staticRenderFns } from "./隐私政策.vue?vue&type=template&id=7ecaa289&scoped=true"
import script from "./隐私政策.vue?vue&type=script&lang=js"
export * from "./隐私政策.vue?vue&type=script&lang=js"
import style0 from "./隐私政策.vue?vue&type=style&index=0&id=7ecaa289&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecaa289",
  null
  
)

export default component.exports